module.exports = __webpack_public_path__ + "img/logo-lab-hoh-symbol.64dd892e.svg";